import { Model } from "@interfaces/model.interface";
import { CuttingToolType } from "@enums/cuttingToolType.enum";
import { RoughFinish } from "@enums/roughFinish.enum";

export interface CuttingTool extends Model {
	defaultFeed?: number;
	defaultRoughFinish?: RoughFinish;
	defaultSpeed?: number;
	defaultStickOut?: string;
	diameter?: string;
	isActive: boolean;
	speedFeedSettings?: string; // JSON: CuttingToolSpeedFeedSetting[]
	toolNumber: string;
	toolType: CuttingToolType;
}

export class CuttingTool implements CuttingTool {
	isActive = true;
	toolNumber = "";
	toolType: CuttingToolType = CuttingToolType.Endmill;

	constructor(data?: Partial<CuttingTool>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
